export const useIsOrgCanUseCopilot = () => {
  return false;
};
